<template>
  <v-footer color="secondary darken-2" dark>
    <v-col class="text-center" cols="12">
      {{ new Date().getFullYear() }} — <strong>ВЭП</strong>
    </v-col>
  </v-footer>
</template>
<script>
export default {}
</script>
